import { render, staticRenderFns } from "./ProductInfoSettingWidget.vue?vue&type=template&id=32faad76&scoped=true&"
import script from "./ProductInfoSettingWidget.vue?vue&type=script&lang=js&"
export * from "./ProductInfoSettingWidget.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfoSettingWidget.vue?vue&type=style&index=0&id=32faad76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32faad76",
  null
  
)

export default component.exports